import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { GALILEU_CREDENTIAL_BASE_ROUTES } from './galileu-credential-base.routes';

export const GALILEU_CREDENTIALS_GALILEU_CREDENTIAL_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...GALILEU_CREDENTIAL_BASE_ROUTES];
  };
}
